/* Tokens only — no literal colour, no literal spacing (`rules/design-system.mdc` §3). */
.root {
  background-color: var(--lw-danger-surface);
  border: 1px solid var(--lw-border-strong);
  border-radius: var(--mantine-radius-md);
  color: var(--lw-danger-text);
}
